// Signals "is this over-target reading a real trim?" -- mirrors the rebalance engine's rule.
//
// strategy/rebalance_logic.py stages a trim (market value back to the effective target) only when
//   target_source is early_defense or grind_defense, OR
//   the defense gate is CONFIRMED (legacy_defense_confirmed), in ANY band.
// A band target drop on its own does NOT trim until the gate confirms, and a confirmed defense
// trims even when the target equals the 40% funded cap (the Sweet-Spot "level trim", CIO kept it
// 2026-11-02). The page used to call every target drop a trim and the level trim "appreciation
// drift" -- both the opposite of what the engine does (P2-5, 2026-11-03).
//
// A funded-cap breach is never a trim (CIO policy 2026-08-13 / 2026-08-27).

export type SignalsTrimKind = "defense" | "grind" | "early_defense";

export interface SignalsTrimInputs {
  /** computeAllocationAction verdict: market weight vs target with the tolerance band. */
  actionState: string;
  targetPct: number | null | undefined;
  fundedCap: number;
  targetSource: string | null | undefined;
  /** get_leaps_snapshot defense_confirmed (legacy gate OR early defense). */
  defenseConfirmed: boolean | null | undefined;
}

export interface SignalsTrimState {
  executable: boolean;
  kind: SignalsTrimKind | null;
  /** Over target after a band target drop, but the sell gate has not confirmed: no trim. */
  gateNotConfirmed: boolean;
}

const CAP_EPS = 0.005;

export function resolveSignalsTrim(i: SignalsTrimInputs): SignalsTrimState {
  if (i.actionState !== "TRIM") return { executable: false, kind: null, gateNotConfirmed: false };
  const kind: SignalsTrimKind | null =
    i.targetSource === "grind_defense"
      ? "grind"
      : i.targetSource === "early_defense"
      ? "early_defense"
      : i.defenseConfirmed === true
      ? "defense"
      : null;
  if (kind) return { executable: true, kind, gateNotConfirmed: false };
  const targetDropped =
    typeof i.targetPct === "number" && Number.isFinite(i.targetPct) && i.targetPct < i.fundedCap - CAP_EPS;
  return { executable: false, kind: null, gateNotConfirmed: targetDropped };
}
